import { render, staticRenderFns } from "./OnboardingVerificationSumsub.vue?vue&type=template&id=e78a2462&"
import script from "./OnboardingVerificationSumsub.vue?vue&type=script&lang=js&"
export * from "./OnboardingVerificationSumsub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports